<div
  class="cursor-container"
  [@fadeInOut]="_state"
  [@scaleInOut]="_state"
  (@fadeInOut.start)="animationStateChanged.emit($event)"
  (@fadeInOut.done)="animationStateChanged.emit($event)"
>
  <div class="cursor-scale" [@mouseDown]="_isMouseDown">
    <div class="cursor-inner">
      <mat-icon svgIcon="add"></mat-icon>
    </div>
  </div>
</div>
